import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CookieNoticePopup = ({ onDismiss }) => {
  const [isVisible, setIsVisible] = useState(true);
  const { t } = useTranslation();

  const handleDismissCookieNotice = () => {
    if (onDismiss) {
      onDismiss();
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50 p-4 sm:p-6">
      <section className="w-full max-w-lg bg-gray-50 py-4 px-6 shadow-md rounded-lg relative">
        <div className="flex flex-col items-center justify-between">
          {/* Cookies Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-24 h-24 text-gray-500 mb-4"
          >
            <path
              fillRule="evenodd"
              d="M12 2.25a9.75 9.75 0 00-1.5 19.384c.23.033.462.05.694.05a9.738 9.738 0 004.557-1.113c.12-.07.23-.157.328-.26.156-.17.234-.4.234-.63v-.143c0-1.072.874-1.944 1.944-1.944h.143c.23 0 .459-.078.63-.234.103-.097.19-.208.26-.328a9.738 9.738 0 001.113-4.557c0-.232-.017-.464-.05-.694A9.75 9.75 0 0012 2.25zM10.5 13.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8 7.5a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15.5 10a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm3 4.75a.75.75 0 100-1.5.75.75 0 000 1.5zm-6.5 3a.75.75 0 100-1.5.75.75 0 000 1.5z"
              clipRule="evenodd"
            />
          </svg>

          {/* Information and Link */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between">
            <div className="flex items-start gap-x-3 mb-4 sm:mb-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 text-gray-500 shrink-0"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                />
              </svg>

              <p className="text-gray-700 text-sm sm:text-base leading-5">
                {t(
                  "We use cookies to enhance your user experience. By continuing to visit this site you agree to"
                )}{" "}
                <Link
                  to="/Cookies"
                  className="underline transition-colors duration-200 hover:text-[#F25668]"
                >
                  {t("our use of cookies")}
                </Link>
              </p>
            </div>
          </div>
          
          {/* Dismiss Button */}
          <button
            onClick={handleDismissCookieNotice}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 focus:outline-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M6.225 5.225a.75.75 0 011.06 0L12 9.94l4.715-4.715a.75.75 0 111.06 1.06L13.06 11l4.715 4.715a.75.75 0 11-1.06 1.06L12 12.06l-4.715 4.715a.75.75 0 11-1.06-1.06L10.94 11 6.225 6.285a.75.75 0 010-1.06z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </section>
    </div>
  );
};

CookieNoticePopup.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

export default CookieNoticePopup;
